// Message.js
import React from "react";
import DocImg from "../../components/docImg";
import { FaSpinner } from "react-icons/fa";
import MainPageDialog, { PageDialogContent } from "../../components/dialog";
import { PdfViewer } from "../../components/pdfViewer";
import { useState } from "react";
import Foxit from "../../components/Foxit";
import FoxitDialog from "../../components/Foxit/FoxitDialog";
import { imageFromUuid } from "../../helpers/utility";

const AttachmentContainer = React.memo(({ data, onRemoveFile, isLoading, openInEditor, callBackFun, onCloseAttachment,  isShowLinkToPatientChartWithImage=false, showMarkReview = false, messageId, pid, compact = false, includeOrigAttachId = false, stackFiles = false }) => {
  const [documentData, setDocumentData] = useState({ isOpen: false });
  const shouldStackFiles = stackFiles && (data?.files?.length || 0) > 1;

  const handleAttachmentClick = (file) => {
    if (file.mime_type === 'application/zip') {
      // For zip files, download using the imageFromUuid function
      if (file.attachment_id) {
        const fileUrl = imageFromUuid(file.attachment_id);
        // Create a hidden anchor element to trigger download
        const a = document.createElement('a');
        a.href = fileUrl;
        a.download = file.title || 'download.zip'; // Use the file title or a default name
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
    } else {
      // For other files, open the viewer dialog
      setDocumentData({ isOpen: true, file });
    }
  };

  return (
    <div className={`flex gap-1 min-w-0 ${shouldStackFiles ? 'flex-col items-start max-w-full w-full' : 'items-center'} ${compact ? 'max-w-full w-full' : ''}`}>
      {data?.files?.map((file, index) => (
        <div
          key={index}
          className={`flex items-start space-x-2 gap-2 relative attachment mb-1 min-w-0 ${shouldStackFiles ? 'max-w-full w-full' : ''} ${compact ? 'max-w-full w-full' : ''}`}
        >
          <div
            className={`cursor-pointer min-w-0 ${shouldStackFiles ? 'max-w-full w-full' : ''} ${compact ? 'max-w-full w-full' : ''} ${file.mime_type === 'application/zip' ? 'hover:bg-gray-100' : ''}`}
            title={file?.title}
            onClick={() => handleAttachmentClick(file)}
          >
            <DocImg file={file} compact={compact || shouldStackFiles} />
          </div>
          {onRemoveFile ? (
            <button
              type="button"
              className="text-black bg-gray-100 rounded-full shadow-sm absolute right-0 top-0 hidden z-10"
              onClick={() => onRemoveFile(index)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="w-4 h-4"
              >
                <path
                  fillRule="evenodd"
                  d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
          ) : null}
        </div>
      ))}
      {isLoading ? (
        <FaSpinner className="animate-spin text-gray-400 " size={20} />
      ) : null}

      {(documentData.isOpen && openInEditor) ? 
        <FoxitDialog
          foxitDialogState={documentData.isOpen}
          setFoxitDialogState={setDocumentData}
          file={documentData.file}
          callBackFun={callBackFun}
          showMarkReview={showMarkReview} 
          messageId={messageId} 
          pid = {pid}
          onCloseAttachment={onCloseAttachment} 
          includeOrigAttachId={includeOrigAttachId}
        />
      : null}
      
      {(documentData.isOpen && !openInEditor && documentData.file?.mime_type !== 'application/zip') && (
        <MainPageDialog
          footer={false}
          title={documentData.file?.title}
          component={
            <PdfViewer
              data={data}
              uuid={documentData.file.attachment_id}
              file={documentData.file}
              closeHandler={() => {
                setDocumentData({});
                onCloseAttachment?.();
              }}
              isShowLinkToPatientChartWithImage={isShowLinkToPatientChartWithImage}
              showMarkReview={showMarkReview} 
              messageId={messageId}  
            />
          }
          onCancelHandler={() => {
            setDocumentData({});
            onCloseAttachment?.(); 
          }}
        />
      )}
    </div>
  );
});

export default AttachmentContainer;